import { setToken } from "./api";
export default {
    registerToken(data) {
        localStorage.setItem("pormoto_token", data.token);
        localStorage.setItem("pormoto_userId", data.userId);
        setToken(data.token);
    },
};
